import { render } from "./pssylttm.vue?vue&type=template&id=2cde7988&scoped=true&ts=true"
import script from "./pssylttm.vue?vue&type=script&lang=ts"
export * from "./pssylttm.vue?vue&type=script&lang=ts"

import "./pssylttm.vue?vue&type=style&index=0&id=2cde7988&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cde7988"]])

export default __exports__